import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35d34550"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("pre", {
    id: "content",
    class: _normalizeClass({'dark-mode': _ctx.darkMode})
  }, [
    _createTextVNode(""),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tokens, (token, index) => {
      return (_openBlock(), _createElementBlock("span", { key: index }, [
        (token === '\n')
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(token), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _createElementVNode("a", {
                href: "#",
                onClick: ($event: any) => (_ctx.addToBuffer($event, token))
              }, _toDisplayString(token), 9, _hoisted_3),
              _createTextVNode()
            ]))
      ]))
    }), 128)),
    _createTextVNode("\n    ")
  ], 2))
}